var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMissingValuesOperationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 20,
    viewBox: "0 0 15 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7502 19.4998H2.2498C1.42281 19.4998 0.75 18.827 0.75 18V1.9998C0.75 1.17281 1.42281 0.5 2.2498 0.5H11.7502C12.5772 0.5 13.25 1.17281 13.25 1.9998V8.5047C10.0569 8.62505 7.4999 11.0437 7.4999 13.9995C7.4999 16.6558 9.57023 18.8827 12.3093 19.391C12.1339 19.4617 11.9444 19.4998 11.7502 19.4998Z",
    fill: "#272D55"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.91263 18.9998C8.15894 17.9232 6.9999 16.0823 6.9999 13.9995C6.9999 10.9254 9.51778 8.38386 12.75 8.03967V1.9998C12.75 1.44851 12.3015 1 11.7502 1H2.2498C1.69851 1 1.25 1.44851 1.25 1.9998V18C1.25 18.5513 1.69851 18.9998 2.2498 18.9998H9.91263ZM11.7502 19.9998H2.2498C1.14711 19.9998 0.25 19.1027 0.25 18V1.9998C0.25 0.89711 1.14711 0 2.2498 0H11.7502C12.8529 0 13.75 0.89711 13.75 1.9998V9.00508C13.6734 9.00205 13.5896 9 13.4998 9C10.4671 9 7.9999 11.2428 7.9999 13.9995C7.9999 16.7483 10.4593 18.9914 13.4824 18.9998C13.1252 19.6172 12.4611 19.9998 11.7502 19.9998Z",
    fill: "#272D55"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 3.5H9.75",
    stroke: "#AECDFC",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 9.5H6.75",
    stroke: "#AECDFC",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.43 12.52C9.43 12.92 9.73 13.13 10.08 13.13C11.05 13.13 10.55 11.81 11.83 11.81C12.43 11.81 12.79 12.13 12.79 12.67C12.79 13.65 11.04 13.92 11.04 15.11C11.04 15.43 11.25 15.78 11.68 15.78C12.34 15.78 12.26 15.29 12.5 14.94C12.82 14.47 14.31 13.97 14.31 12.67C14.31 11.26 13.05 10.67 11.77 10.67C10.55 10.67 9.43 11.54 9.43 12.52ZM10.9 17.25C10.9 17.7 11.27 18.07 11.72 18.07C12.17 18.07 12.54 17.7 12.54 17.25C12.54 16.8 12.17 16.43 11.72 16.43C11.27 16.43 10.9 16.8 10.9 17.25Z",
    fill: "#272D55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMissingValuesOperationIcon);
export default __webpack_public_path__ + "static/media/MissingValuesOperationIcon.7b9043d4177ac6570950912069baee16.svg";
export { ForwardRef as ReactComponent };